export default __webpack_public_path__ + "assets/fonts/c0d0dea8a57a2a9d540734043b35e7e4.woff2";